import { LoadingOverlay } from "@mantine/core";
import { useReportingStore } from "../../../stores/ReportingStore";

const LoaderStats = ({
  borderRadius = 12,
  isDate,
  isProgStats,
  defaultLoading,
}) => {
  const loading = useReportingStore((s) => s.loading);
  const loadingDate = useReportingStore((s) => s.loadingDate);
  const loadingProgs = useReportingStore((s) => s.loadingProgStats);

  return (
    <LoadingOverlay
      visible={
        defaultLoading
          ? defaultLoading
          : isDate
          ? loadingDate
          : isProgStats
          ? loadingProgs
          : loading
      }
      styles={{ overlay: { borderRadius } }}
    />
  );
};

export default LoaderStats;
